import Chip, { ChipProps } from '@mui/material/Chip';
import { styled } from '@mui/material/styles';

/** Compact “Recommended” pill (Clay-style) — positioned top-right of the card */
const StyledRecommendedChip = styled(Chip)<ChipProps>(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2),
  height: 26,
  fontSize: '0.6875rem',
  fontWeight: 600,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  borderRadius: 999,
}));

export default StyledRecommendedChip;
